<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AccountMenuAppendItems extends Vue {
        render() {
            return null
        }
    }

    export default AccountMenuAppendItems
</script>
